<template>
  <span :aria-hidden="decorative"
        :aria-label="title"
        class="material-design-icon plus-icon"
        role="img"
        @click="$emit('click', $event)">
    <img src="icons/trash-can-solid-full.svg" :alt="title" style="width:20px;height:20px" />
  </span>
</template>

<script>
export default {
  name: "InrsDeleteIcon",
  props: {
    title: {
      type: String,
      default: "Supprimer"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>
